module.exports = __webpack_public_path__ + "img/logo.86305383.png";